<template>
    <div id="main">
        <div id="sidebar" lighten-1>
            <h1># moopmoop</h1>
            <SearchBox hint="Van" v-on:set-location="start_location = $event"></SearchBox>
            <SearchBox hint="Naar" v-on:set-location="end_location = $event"></SearchBox>
            
            <div class="time_selection">

                <v-select
                :items="time_select_options"
                dark
                class="time_select_options"
                v-model="time_select_default"
                ></v-select>

                <vue-timepicker v-if="select_time_manually" v-model="custom_time" :minute-interval="5" close-on-complete class="time_select"></vue-timepicker>
                <v-radio-group v-if="select_time_manually" v-model="date_quick_selection" row dark>
                    <v-radio label="Vandaag" value="today"></v-radio>
                    <v-radio label="Morgen" value="tomorrow"></v-radio>
                    <v-radio label="Andere dag" value="different"></v-radio>
                </v-radio-group>

                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="200px"
                    v-if="select_date_manually"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="date"
                        label="Reisdatum"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dark
                    ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable @change="menu = false">
                    </v-date-picker>
                </v-menu>
                <v-expansion-panels accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>Geavanceerde opties</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row justify="space-around" align-content-start>
                            <v-radio-group  label="Voortransport" v-model="access_mode">
                                    <v-radio label="Lopen" value="walking"></v-radio>
                                    <v-radio label="Fietsen" value="cycling"></v-radio>
                            </v-radio-group>
                            <v-radio-group  label="Natransport" v-model="egress_mode">
                                <v-radio label="Lopen" value="walking"></v-radio>
                                <v-radio label="Fietsen" value="cycling"></v-radio>
                            </v-radio-group>
                        </v-row>
                        Hoever wil je maximaal lopen / rijden?
                        <v-slider
                            v-model="egress_duration"
                            :tick-labels="egress_time_choices"
                            :max="2"
                            step="1"
                            ticks="always"
                            tick-size="2"
                        >
                        </v-slider>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <v-btn medium color="primary" block v-on:click="plan">Plan</v-btn>
            <PlanResults :request="request" class="plan_results" @show-travel-option="showTravelOption"></PlanResults>
        </div>
        <TravelOptionDetail v-if="selected_travel_option !== null" v-bind:travelLegs="selected_travel_option"></TravelOptionDetail>
        <Map v-bind:travelOptionDetailActive="selected_travel_option !== null"></Map>
    </div>

</template>

<script>
import SearchBox from './SearchBox';
import VueTimepicker from 'vue2-timepicker';
import PlanResults from './PlanResults';
import TravelOptionDetail from './TravelOptionDetail';
import moment from 'moment';
import Map from './Map.vue'

export default {
  components: {
      SearchBox,
      VueTimepicker,
      PlanResults,
      TravelOptionDetail,
      Map,
  },
  data() {
    return {
      console,
      counter: 0,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      time_select_options: [
        {value: "depart_now", text: "Nu vertrekken" },
        {value: "depart_on", text: "Vertrekken om" },
        {value: "arrive_on", text: "Aankomen om"},
      ],
      time_select_default: "depart_now",
      date_quick_selection: "today",
      custom_time: {
        HH: (new Date()).getHours().toString(),
        mm: (5 * Math.round(new Date().getMinutes()/5)).toString(),
      },

      start_location: null,
      end_location: null,
      access_mode: null,
      egress_mode: null,
      egress_time_choices: [
        '10 min.',
        '25 min.',
        '40 min.',
      ],
      egress_duration: 0,
      request: null,
      selected_travel_option: null,
    };
  },

  computed: {
    select_time_manually: function () {
        if(this.time_select_default === "depart_now") {
            return false;
        }
        return true;
    },
    select_date_manually: function () {
        if(this.time_select_default !== "depart_now" && this.date_quick_selection === "different") {
            return true;
        }
        return false;
    }

  },

  methods: {
      plan: function(event) {
          var arrive_by = false;
          var date = moment();
          this.selected_travel_option = null;
          switch(this.time_select_default) {
              case "depart_now":
                break;
              case "depart_on":
                date = this.update_time(this.get_date());
                break;
              case "arrive_on":
                date = this.update_time(this.get_date());
                arrive_by = true;
                break;
          }
          console.log(date.format());
          this.request = {
              start_location: this.start_location,
              end_location: this.end_location,
              arrive_by: arrive_by,
              timestamp: date.format(),
          };

      },
      get_date: function() {
          switch(this.date_quick_selection) {
              case "today":
                return moment();
              case "tomorrow":
                return moment().add(1, 'days');
              case "different":
                return moment(this.date);
          }   
      },
      update_time: function(timestamp) {
          timestamp.set('hour', this.custom_time.HH);
          timestamp.set('minute', this.custom_time.mm);
          return timestamp; 
      },
      showTravelOption: function(event) {
          this.selected_travel_option = event;
      }
  },

};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
@import '~vue2-timepicker/dist/VueTimepicker.css';

#main {
    height: 100%;
    display: flex;
}

#sidebar {
    width: 400px;
    height: 100vh;
    background-color: #2C343E;
    color: white;
    display: inline-block;
}


h1 {
    text-align: center;
    font: 42px/52px;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -4.68px;
    color: #FAFAFA;
    opacity: 1;
    padding: 20px 0 10px 0;
}

.time_selection {
    background-color: #040506;
    margin-top: 6px;
    width: 100%;
    padding: 15px 12px;
}

.time_select_options {
    margin-left: 20px;
    width: 150px;
    display: inline-block;
}

.time_select {
    margin-left: 25px;
    padding: 0;
    display: inline-block;
}

.plan_results{
    margin: 5px;
    padding: 1px;
}
</style>
